import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-md-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "登录失败!", -1 /* HOISTED */)
const _hoisted_5 = { class: "col-md-8" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "自动登录", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_alert = _resolveComponent("b-alert")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_link = _resolveComponent("b-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.authenticationError)
          ? (_openBlock(), _createBlock(_component_b_alert, {
              key: 0,
              show: "",
              "data-cy": "loginError",
              variant: "danger"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" 请检查您的登录信息, 并重试一次.")
              ], undefined, true),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_b_form, {
          role: "form",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.doLogin()), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, {
              label: "账号",
              "label-for": "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_input, {
                  id: "username",
                  type: "text",
                  name: "username",
                  autofocus: "",
                  placeholder: "您的账号",
                  modelValue: _ctx.login,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.login) = $event)),
                  "data-cy": "username"
                }, null, 8 /* PROPS */, ["modelValue"])
              ], undefined, true),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_b_form_group, {
              label: "密码",
              "label-for": "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_input, {
                  id: "password",
                  type: "password",
                  name: "password",
                  placeholder: "您的密码",
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                  "data-cy": "password"
                }, null, 8 /* PROPS */, ["modelValue"])
              ], undefined, true),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_b_form_checkbox, {
              id: "rememberMe",
              name: "rememberMe",
              modelValue: _ctx.rememberMe,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rememberMe) = $event)),
              checked: ""
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ], undefined, true),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]),
            _createElementVNode("div", null, [
              _createVNode(_component_b_button, {
                "data-cy": "submit",
                type: "submit",
                variant: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("登录")
                ], undefined, true),
                _: 1 /* STABLE */
              })
            ])
          ], undefined, true),
          _: 1 /* STABLE */
        }),
        _hoisted_7,
        _createElementVNode("div", null, [
          _createVNode(_component_b_alert, {
            show: "",
            variant: "warning"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_link, {
                to: '/account/reset/request',
                class: "alert-link",
                "data-cy": "forgetYourPasswordSelector"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("忘记密码?")
                ], undefined, true),
                _: 1 /* STABLE */
              })
            ], undefined, true),
            _: 1 /* STABLE */
          })
        ]),
        _createCommentVNode("\n        <div>\n          <b-alert show variant=\"warning\">\n            <span>您还没有账号</span>\n            <b-link :to=\"'/register'\" class=\"alert-link\">注册一个新账号</b-link>\n          </b-alert>\n        </div>\n        ")
      ])
    ])
  ]))
}